module.exports = __webpack_public_path__ + "f572638f/img/upload-icon.9179ae4e.svg";